export default "__VITE_ASSET__e6071843__"